import { useSelector } from 'react-redux';
import {
    selectHasPermission,
    selectHasAnyPermission,
    selectHasAllPermissions,
    selectPermissionsLoading,
    selectPermissionsError
} from '../store/slices/permissionsSlice';

/**
 * Custom hook for checking user permissions
 * @returns {Object} Permission checking utilities
 */
export const usePermissions = () => {
    const loading = useSelector(selectPermissionsLoading);
    const error = useSelector(selectPermissionsError);

    return {
        loading,
        error,
    };
};

/**
 * Hook to check a single permission
 * @param {string} permission - The permission to check
 * @returns {boolean} Whether user has the permission
 */
export const useHasPermission = (permission) => {
    return useSelector(selectHasPermission(permission));
};

/**
 * Hook to check multiple permissions with OR logic
 * @param {string[]} permissions - Array of permissions to check
 * @returns {boolean} Whether user has at least one permission
 */
export const useHasAnyPermission = (permissions) => {
    return useSelector(selectHasAnyPermission(permissions));
};

/**
 * Hook to check multiple permissions with AND logic
 * @param {string[]} permissions - Array of permissions to check
 * @returns {boolean} Whether user has all permissions
 */
export const useHasAllPermissions = (permissions) => {
    return useSelector(selectHasAllPermissions(permissions));
};

export default usePermissions;
